// Static placeholders for brand & contact info — easy to update later.
export const BRAND = {
  name: "Weston Commercial Center",
  shortName: "Weston Commercial",
  tagline: "Professional Office Space in Weston, Florida",
  phone: "954-384-6949",
  phoneRaw: "+19543846949",
  phoneSecondary: "954-627-9125",
  phoneSecondaryRaw: "+19546279125",
  email: "pmwestoncc@stiles.com",
  address: {
    street: "2600 Glades Circle",
    suite: "Suite 100",
    city: "Weston",
    state: "FL",
    zip: "33327",
  },
  hours: [
    { label: "Monday – Friday", value: "8:30 AM – 6:00 PM" },
    { label: "Saturday", value: "By appointment" },
    { label: "Sunday", value: "Closed" },
  ],
  leasingAgent: {
    name: "Elismarie Fernandez",
    title: "Property Manager",
  },
  socials: {
    instagram: "#",
    linkedin: "#",
  },
  googleMapsEmbed:
    "https://www.google.com/maps?q=2600+Glades+Circle+Suite+100+Weston+FL+33327&output=embed",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Available Spaces", to: "/available-spaces" },
  { label: "Amenities", to: "/amenities" },
  { label: "Location", to: "/location" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const SPACES = [
  {
    slug: "private-offices",
    name: "Private Offices",
    eyebrow: "01 — Focused work",
    short:
      "Fully enclosed, lockable offices designed for focused work and quiet client conversations.",
    suiteSize: "120 – 280 sq ft",
    startingRate: "$895",
    rateUnit: "/ month",
    availability: "Available",
    capacity: "1 – 3 people",
    bestFor: [
      "Solo professionals",
      "Attorneys & paralegals",
      "Accountants & CPAs",
      "Independent consultants",
    ],
    overview:
      "A quiet, lockable office of your own — fully furnished and move-in ready. Whether you take meetings by phone all day or need a refined backdrop for in-person clients, our private offices give you the calm of a single-tenant suite with the convenience of a fully-serviced building.",
    features: [
      "Fully furnished, move-in ready",
      "Gigabit business internet",
      "Conference room credits each month",
      "24/7 secured building access",
      "Reception, mail & package handling",
      "Flexible month-to-month terms",
    ],
    floorplans: [
      { label: "Suite 210", size: "138 sq ft", note: "Interior · 1 desk" },
      { label: "Suite 224", size: "186 sq ft", note: "Window · 1–2 desks" },
      { label: "Suite 308", size: "262 sq ft", note: "Corner · 2 desks" },
    ],
    image:
      "https://images.unsplash.com/photo-1703355685722-2996b01483be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxwcml2YXRlJTIwb2ZmaWNlJTIwc3VpdGUlMjBtb2Rlcm4lMjB3aW5kb3d8ZW58MHx8fHwxNzgxMTkxMDc0fDA&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1703355685722-2996b01483be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxwcml2YXRlJTIwb2ZmaWNlJTIwc3VpdGUlMjBtb2Rlcm4lMjB3aW5kb3d8ZW58MHx8fHwxNzgxMTkxMDc0fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1628062699790-7c45262b82b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBvZmZpY2UlMjBtZWV0aW5nJTIwcm9vbXxlbnwwfHx8fDE3ODExOTEwNzR8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1758448511255-ac2a24a135d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwb2ZmaWNlJTIwbG91bmdlJTIwYXJlYXxlbnwwfHx8fDE3ODExOTEwNzR8MA&ixlib=rb-4.1.0&q=85",
    ],
  },
  {
    slug: "executive-suites",
    name: "Executive Suites",
    eyebrow: "02 — Signature corner",
    short:
      "Premium corner suites with floor-to-ceiling windows and a dedicated client-meeting area.",
    suiteSize: "300 – 550 sq ft",
    startingRate: "$1,650",
    rateUnit: "/ month",
    availability: "Limited",
    capacity: "2 – 6 people",
    bestFor: [
      "Founders & CEOs",
      "Boutique advisory firms",
      "Financial advisors",
      "Specialist medical practices",
    ],
    overview:
      "Our executive suites occupy the window-line of each floor — wide views, generous proportions, and a dedicated nook for meeting clients in private. Every suite is finished with a curated furniture package and serviced daily.",
    features: [
      "Window-line suites with natural light",
      "Built-in meeting area for 2–4 guests",
      "Designer furniture package",
      "Priority booking for boardrooms",
      "Concierge reception service",
      "Covered, reserved parking",
    ],
    floorplans: [
      { label: "Suite 410", size: "318 sq ft", note: "Corner · 1 office + nook" },
      { label: "Suite 504", size: "420 sq ft", note: "Window · L-shape suite" },
      { label: "Suite 612", size: "548 sq ft", note: "Corner · Boardroom-ready" },
    ],
    image:
      "https://images.unsplash.com/photo-1628062699790-7c45262b82b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBvZmZpY2UlMjBtZWV0aW5nJTIwcm9vbXxlbnwwfHx8fDE3ODExOTEwNzR8MA&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1628062699790-7c45262b82b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBvZmZpY2UlMjBtZWV0aW5nJTIwcm9vbXxlbnwwfHx8fDE3ODExOTEwNzR8MA&ixlib=rb-4.1.0&q=85",
      "https://images.pexels.com/photos/19893586/pexels-photo-19893586.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      "https://images.unsplash.com/photo-1600531529272-023c4b821f14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjBidWlsZGluZyUyMGV4dGVyaW9yJTIwZ2xhc3MlMjBtb2Rlcm58ZW58MHx8fHwxNzgxMTkxMDgwfDA&ixlib=rb-4.1.0&q=85",
    ],
  },
  {
    slug: "office-suites",
    name: "Office Suites",
    eyebrow: "03 — Self-contained",
    short:
      "Multi-room suites that grow with you — front-of-house, breakout, and private offices combined.",
    suiteSize: "600 – 1,400 sq ft",
    startingRate: "$2,750",
    rateUnit: "/ month",
    availability: "Available",
    capacity: "4 – 12 people",
    bestFor: [
      "Insurance agencies",
      "Real estate teams",
      "Boutique law firms",
      "Established consultancies",
    ],
    overview:
      "Office suites give you the privacy of a self-contained floor with the convenience of a serviced building. Each suite is a small studio in itself — reception, breakout area, and three to six private offices — branded to your firm.",
    features: [
      "Multi-room configurations",
      "Private reception area",
      "Direct-dial business phone lines",
      "Branded signage opportunity",
      "Dedicated server / IT closet",
      "Customisable build-out options",
    ],
    floorplans: [
      { label: "Suite 220", size: "660 sq ft", note: "3 offices · reception" },
      { label: "Suite 405", size: "980 sq ft", note: "4 offices · breakout" },
      { label: "Suite 620", size: "1,395 sq ft", note: "6 offices · conference room" },
    ],
    image:
      "https://images.pexels.com/photos/19893586/pexels-photo-19893586.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    gallery: [
      "https://images.pexels.com/photos/19893586/pexels-photo-19893586.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      "https://images.unsplash.com/photo-1758448511255-ac2a24a135d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwb2ZmaWNlJTIwbG91bmdlJTIwYXJlYXxlbnwwfHx8fDE3ODExOTEwNzR8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1703355685722-2996b01483be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxwcml2YXRlJTIwb2ZmaWNlJTIwc3VpdGUlMjBtb2Rlcm4lMjB3aW5kb3d8ZW58MHx8fHwxNzgxMTkxMDc0fDA&ixlib=rb-4.1.0&q=85",
    ],
  },
  {
    slug: "team-offices",
    name: "Team Offices",
    eyebrow: "04 — Built for teams",
    short:
      "Open, configurable workspaces sized for collaborative teams of four to twenty-five.",
    suiteSize: "450 – 1,800 sq ft",
    startingRate: "$1,950",
    rateUnit: "/ month",
    availability: "Available",
    capacity: "4 – 25 people",
    bestFor: [
      "Startups",
      "Remote teams returning to office",
      "Marketing & creative agencies",
      "Healthcare admin teams",
    ],
    overview:
      "Open-plan workspaces engineered for hybrid teams. Configure the layout to your headcount, add phone booths and a private conference room, and bring everyone together without the multi-year lease commitment.",
    features: [
      "Open-plan layout, configurable",
      "Dedicated team conference room",
      "Quiet phone booths",
      "Kitchen, lounge & wellness access",
      "Bike storage & shower facilities",
      "Scales from 4 to 25 desks",
    ],
    floorplans: [
      { label: "Suite 115", size: "468 sq ft", note: "6 desks · phone booth" },
      { label: "Suite 320", size: "1,120 sq ft", note: "14 desks · conference room" },
      { label: "Suite 510", size: "1,790 sq ft", note: "22 desks · breakout + booths" },
    ],
    image:
      "https://images.unsplash.com/photo-1758448511255-ac2a24a135d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwb2ZmaWNlJTIwbG91bmdlJTIwYXJlYXxlbnwwfHx8fDE3ODExOTEwNzR8MA&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1758448511255-ac2a24a135d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwb2ZmaWNlJTIwbG91bmdlJTIwYXJlYXxlbnwwfHx8fDE3ODExOTEwNzR8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1628062699790-7c45262b82b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBvZmZpY2UlMjBtZWV0aW5nJTIwcm9vbXxlbnwwfHx8fDE3ODExOTEwNzR8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1600531529272-023c4b821f14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjBidWlsZGluZyUyMGV4dGVyaW9yJTIwZ2xhc3MlMjBtb2Rlcm58ZW58MHx8fHwxNzgxMTkxMDgwfDA&ixlib=rb-4.1.0&q=85",
    ],
  },
];

export const SPACES_BY_SLUG = Object.fromEntries(SPACES.map((s) => [s.slug, s]));

export const AMENITIES = [
  { key: "internet", title: "Gigabit Internet", desc: "Redundant business-grade fibre with a dedicated VLAN for every tenant.", icon: "Wifi" },
  { key: "conference", title: "Conference Rooms", desc: "Bookable boardrooms and huddle spaces, video-ready and concierge supported.", icon: "Users" },
  { key: "reception", title: "Front Reception", desc: "On-site reception team to greet your guests and handle deliveries.", icon: "BellRing" },
  { key: "parking", title: "Covered Parking", desc: "Reserved tenant parking with visitor spaces and EV chargers nearby.", icon: "ParkingSquare" },
  { key: "kitchen", title: "Kitchen & Café", desc: "Specialty coffee, filtered water, and a fully stocked tenant café.", icon: "Coffee" },
  { key: "access", title: "24/7 Access", desc: "Keycard access any time of day, every day of the year.", icon: "KeyRound" },
  { key: "security", title: "On-Site Security", desc: "Monitored entry, CCTV, and a daytime security presence on every floor.", icon: "ShieldCheck" },
  { key: "mail", title: "Mail Handling", desc: "Business mailing address, scanning, and package logistics included.", icon: "Mailbox" },
  { key: "flexible", title: "Flexible Terms", desc: "Month-to-month, annual, and multi-year terms with transparent pricing.", icon: "CalendarRange" },
];

export const WHY_REASONS = [
  { title: "Prime Weston Location", body: "Minutes from I-75 and the Sawgrass Expressway, surrounded by national restaurants and hotels.", icon: "MapPin" },
  { title: "Effortless Highway Access", body: "Reach Fort Lauderdale, Miami and Boca within a single uninterrupted drive.", icon: "Route" },
  { title: "Professional Community", body: "A curated mix of law firms, advisors, healthcare practices and growing teams.", icon: "Briefcase" },
  { title: "Move-In Ready", body: "Furnished suites with internet, utilities and reception included from day one.", icon: "PackageCheck" },
  { title: "Transparent, Flexible Leasing", body: "Month-to-month and multi-year terms — no opaque CAM charges, no surprises.", icon: "FileSignature" },
  { title: "Hospitality-Grade Service", body: "An on-site team that treats your tenants and guests like guests of a hotel.", icon: "Sparkles" },
];

export const TESTIMONIALS = [
  {
    quote:
      "We toured eight buildings in Weston before signing here. The light, the reception team, and the boardrooms made it a different category entirely.",
    author: "Daniela Reyes",
    role: "Managing Partner, Reyes & Whitcomb Law",
  },
  {
    quote:
      "Our team grew from six to nineteen people without ever changing buildings. The flexibility — and the coffee — kept us put.",
    author: "Marcus Holloway",
    role: "Founder, Holloway Capital Advisors",
  },
  {
    quote:
      "Clients comment on the lobby every single visit. It feels like a private member's office, not a leasing centre.",
    author: "Priya Anand",
    role: "Director of Operations, Anand Health Group",
  },
];

export const STATS = [
  { value: "94%", label: "Tenant retention" },
  { value: "120+", label: "Resident businesses" },
  { value: "8", label: "Floors of workspace" },
  { value: "2014", label: "Established" },
];

export const FAQS = [
  {
    q: "What lease terms do you offer?",
    a: "Month-to-month, annual, and multi-year terms are all available. Most tenants start on a 12-month agreement; we keep the language plain and the renewals automatic.",
  },
  {
    q: "Is parking included?",
    a: "Yes. Covered tenant parking is included with every lease, and we hold dedicated visitor spaces at the front of the building. EV charging is available a short walk away.",
  },
  {
    q: "What's included with the internet?",
    a: "Gigabit fibre with a dedicated VLAN for your business, redundant carriers, and a 99.99% uptime SLA. Bring your own router or use ours.",
  },
  {
    q: "How quickly can we move in?",
    a: "Most furnished suites are ready within 48–72 hours of signing. Custom build-outs and signage typically take 2–3 weeks.",
  },
  {
    q: "Can we host clients here?",
    a: "Absolutely. Reception greets every guest by name, and conference room credits are included with every lease — book them by the hour or the day.",
  },
  {
    q: "What office sizes are available?",
    a: "Private offices start at 120 sq ft and team suites scale to 1,800 sq ft. We'll walk you through the floor plate and help you size correctly for the next 24 months.",
  },
  {
    q: "Are utilities and cleaning included?",
    a: "Yes — water, electricity, HVAC, daily cleaning of common areas, and twice-weekly office cleaning are all part of the lease.",
  },
];

export const GALLERY = [
  { src: "https://images.pexels.com/photos/19893586/pexels-photo-19893586.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "Lobby & reception" },
  { src: "https://images.unsplash.com/photo-1758448511255-ac2a24a135d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwb2ZmaWNlJTIwbG91bmdlJTIwYXJlYXxlbnwwfHx8fDE3ODExOTEwNzR8MA&ixlib=rb-4.1.0&q=85", caption: "Tenant lounge" },
  { src: "https://images.unsplash.com/photo-1703355685722-2996b01483be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxwcml2YXRlJTIwb2ZmaWNlJTIwc3VpdGUlMjBtb2Rlcm4lMjB3aW5kb3d8ZW58MHx8fHwxNzgxMTkxMDc0fDA&ixlib=rb-4.1.0&q=85", caption: "Private office" },
  { src: "https://images.unsplash.com/photo-1628062699790-7c45262b82b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBvZmZpY2UlMjBtZWV0aW5nJTIwcm9vbXxlbnwwfHx8fDE3ODExOTEwNzR8MA&ixlib=rb-4.1.0&q=85", caption: "Boardroom" },
  { src: "https://images.unsplash.com/photo-1600531529272-023c4b821f14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjBidWlsZGluZyUyMGV4dGVyaW9yJTIwZ2xhc3MlMjBtb2Rlcm58ZW58MHx8fHwxNzgxMTkxMDgwfDA&ixlib=rb-4.1.0&q=85", caption: "Building exterior" },
];

export const TEAM_SIZE_OPTIONS = [
  "Just me",
  "2 – 5 people",
  "6 – 10 people",
  "11 – 25 people",
  "More than 25",
];

export const OFFICE_TYPE_OPTIONS = [
  "Private Offices",
  "Executive Suites",
  "Office Suites",
  "Team Offices",
  "Not sure yet — show me everything",
];
